var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.40625H10.5703V2.48438C10.5703 3.06799 10.0992 3.53906 9.51562 3.53906C8.93201 3.53906 8.46094 3.06799 8.46094 2.48438H9.16406C9.16406 2.68127 9.31873 2.83594 9.51562 2.83594C9.71252 2.83594 9.86719 2.68127 9.86719 2.48438V1.40625H9.16406V1.05469C9.16406 0.857789 9.31873 0.703125 9.51562 0.703125C9.71252 0.703125 9.86719 0.857789 9.86719 1.05469V1.40602H10.5703V1.05469C10.5703 0.47107 10.0992 0 9.51562 0C8.93201 0 8.46094 0.47107 8.46094 1.05469V1.40625H7.05469V2.48438C7.05469 3.06799 6.58362 3.53906 6 3.53906C5.41638 3.53906 4.94531 3.06799 4.94531 2.48438H5.64844C5.64844 2.68127 5.8031 2.83594 6 2.83594C6.1969 2.83594 6.35156 2.68127 6.35156 2.48438V1.40625H5.64844V1.05469C5.64844 0.857789 5.8031 0.703125 6 0.703125C6.1969 0.703125 6.35156 0.857789 6.35156 1.05469V1.40602H7.05469V1.05469C7.05469 0.47107 6.58362 0 6 0C5.41638 0 4.94531 0.47107 4.94531 1.05469V1.40625H3.53906V2.48438C3.53906 3.06799 3.06799 3.53906 2.48438 3.53906C1.90076 3.53906 1.42969 3.06799 1.42969 2.48438H2.13281C2.13281 2.68127 2.28748 2.83594 2.48438 2.83594C2.68127 2.83594 2.83594 2.68127 2.83594 2.48438V1.40625H2.13281V1.05469C2.13281 0.857789 2.28748 0.703125 2.48438 0.703125C2.68127 0.703125 2.83594 0.857789 2.83594 1.05469V1.40602H3.53906V1.05469C3.53906 0.47107 3.06799 0 2.48438 0C1.90076 0 1.42969 0.47107 1.42969 1.05469V1.40625H0V4.24219H12V1.40625Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 8.10938H4.24219V8.81318H5.64844V8.10938Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 8.10938H2.13281V8.81318H3.53906V8.10938Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 9.51561H4.24219V10.2194H5.64844V9.51561Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 8.10938H6.35156V8.81318H7.75781V8.10938Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 9.51561H2.13281V10.2194H3.53906V9.51561Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86719 6.70311H8.46094V7.4069H9.86719V6.70311Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.94534H0V12H12V4.94534ZM10.5703 9.51565H8.46094V10.9219H1.42969V7.40627H5.64844V6.00002H10.5703V9.51565Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 6.70311H6.35156V7.4069H7.75781V6.70311Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75781 9.51561H6.35156V10.2194H7.75781V9.51561Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86719 8.10938H8.46094V8.81318H9.86719V8.10938Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.97648c58.svg";
export { ForwardRef as ReactComponent };